import classNames from 'classnames';
import React, { useCallback, useState } from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { Input } from '@eika/input';
import { ErrorLabel } from '@eika/label';

import useNoteMaxLength from '../../../../hooks/useNoteMaxLength';
import useTranslation, { format } from '../../../../hooks/useTranslation';

import './OwntextInput.scss';

export interface OwntextInputProps {
    className?: string;
    ownText?: string;
    locked?: boolean;
    onChangeOwntext: (value: string) => void;
    label?: string;
    placeholder?: string;
    avtaleGiro?: boolean;
}

const OwntextInput: React.FC<OwntextInputProps> = ({
    className,
    onChangeOwntext,
    ownText = '',
    label,
    placeholder,
    locked = false,
    avtaleGiro = false,
}) => {
    const translated = useTranslation();
    const noteMaxLength = useNoteMaxLength(avtaleGiro);
    const [localError, setLocalError] = useState<string>();

    const onChangeEvent = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const targetValue = e.target.value;
            setLocalError(undefined);

            const snipped = targetValue.length >= noteMaxLength ? targetValue.substring(0, noteMaxLength) : targetValue;

            if (targetValue.length > noteMaxLength) {
                setLocalError(format(translated.tooManyCharacters, noteMaxLength));
            }

            onChangeOwntext(snipped);
        },
        [noteMaxLength, onChangeOwntext, translated.tooManyCharacters],
    );

    return (
        <details className={classNames('owntext-selector__wrapper', className)}>
            <summary className="owntext-selector-summary">
                <span>{label ?? translated.paymentAddOwnText}</span>
                <Icon type={IconTypes.LITEN_PIL_NED} ariaLabel="Utvid input for egen tekst" />
                {locked && (
                    <Icon
                        className="payment-padlock-icon owntext-locked-icon"
                        type={IconTypes.PIN_KODE_24}
                        ariaLabel="Låst"
                    />
                )}
            </summary>
            <div className="owntext-selector-content__wrapper">
                <div className="transaction-form__owntext-input">
                    <Input
                        name="owntextIinput"
                        className="owntext__input"
                        value={ownText}
                        placeholder={placeholder ?? translated.ownTextPlaceholder}
                        maxLength={noteMaxLength + 1}
                        onChange={onChangeEvent}
                        data-focus-first
                        type="text"
                        disabled={locked}
                    />
                    {localError && <ErrorLabel icon={IconTypes.UTROPSTEGN_24} text={localError} />}
                </div>
            </div>
        </details>
    );
};

export default OwntextInput;
